import { NgModule } from '@angular/core';
import { CheckinSearchResultStoreModule } from '../checkin-search-result-store/checkin-search-result-store.service.module';
import { CprResultStoreService } from '../cpr-result-store/cpr-result-store.service';
import { CheckinSearchService } from './checkin-search.service';

@NgModule({
  imports: [CheckinSearchResultStoreModule],
  providers: [CheckinSearchService, CprResultStoreService, CheckinSearchResultStoreModule],
})
export class CheckinSearchServiceModule {}
